/**
 * 星迹4
 */
declare global {
  interface Window {
    QimeiWeb: any;
  }
}

interface QimeiParams {
  [key: string]: string | number | undefined | boolean | Array<string | number>;
}

interface QimeiResult {
  uskey?: string;
  h38?: string;
}

interface QimeiWebInstance {
  h42: string;
  getQimei36(): void;
  getLocalQimei36(): { h38: string };
  getUSKeySync(busId: string, h38: string, infos: string): string;
}

const BUS_ID = '7800406';
const APP_ID = '0WEB06ILNBLCEI7D';

class QimeiWebDefend {
  qimeiWeb: QimeiWebInstance | null = null;
  public init(): void {
    try {
      if (this.qimeiWeb) return;
      if (!window.QimeiWeb) return;
      this.qimeiWeb = new window.QimeiWeb({
        appKey: APP_ID,
        disableDebugger: true,
      });
      this.qimeiWeb?.getQimei36();
    } catch (error) {
      console.error('Failed to load QimeiWeb:', error);
    }
  }

  /**
   * 生成Qimei参数
   * @param params 需要签名的参数对象
   * @returns 包含uskey和h38的结果对象
   */
  public generateQimeiParams(params: QimeiParams): QimeiResult {
    try {
      if (!this.qimeiWeb) {
        this.init();
        if (!this.qimeiWeb) return {};
      }
      const infos = this.stringifyParams(params);
      let { h38 } = this.qimeiWeb.getLocalQimei36();
      const { h42 } = this.qimeiWeb;
      h38 = h38 || h42;
      return {
        uskey: this.qimeiWeb.getUSKeySync(BUS_ID, h38, infos),
        h38,
      };
    } catch (error) {
      return {};
    }
  }

  private stringifyParams(params: QimeiParams): string {
    try {
      const paramArr: string[] = [];
      // params 按字母顺序拼接
      const keys = Object.keys(params).sort();
      keys.forEach((key) => {
        const value = params[key];
        // 过滤掉 undefined null ''
        if (value !== undefined && value !== null && value !== '') {
          paramArr.push(`${key}=${value}`);
        }
      });
      const infos = paramArr.join('&');
      return infos;
    } catch (error) {
      return '';
    }
  }
}

const qimeiWebDefend = new QimeiWebDefend();

export default qimeiWebDefend;
